import { IComputeDaysAndHours } from '../functions/get-days-or-hours'
import { ILeaveDayDetails } from './leave-request'
import { IWorkingSchedule, WorkingHours } from './work-week'

export type MessageFormatPrimitiveValue = string | number | boolean | null | undefined

export enum LeaveDisplayFormatEnum {
  long = 'long',
  short = 'short',
  none = 'none'
}

export enum QuotaDisplayFormatEnum {
  formatted = 'formatted',
  raw = 'raw'
}

export interface IFormatMessage {
  id: string
  values?: Record<string, MessageFormatPrimitiveValue>
}

export interface IDisplayLeaveDuration {
  value: number
  hourlyLeaveAccounting?: boolean
  format?: LeaveDisplayFormatEnum
  formatMessage?: IFormatMessageFn
  daysList?: ILeaveDayDetails[]
  hasSchedule?: boolean
}

export interface IDisplayLeaveDurationBots {
  value: number
  hourlyLeaveAccounting?: boolean
  format?: LeaveDisplayFormatEnum
  formatMessage: IFormatMessageFn
  daysList?: ILeaveDayDetails[]
}

export interface IDisplayLeaveInDaysAndHoursBots {
  value: number
  formatMessage: IFormatMessageFn
  hourlyLeaveAccounting?: boolean
  format?: LeaveDisplayFormatEnum
  workingHours: WorkingHours | IWorkingSchedule
}

export interface IGetFormattedDaysAndHours {
  leave: IComputeDaysAndHours
  formatMessage: IFormatMessageFn
  displayFormat: LeaveDisplayFormatEnum
}

export type IFormatMessageFn = (d: IFormatMessage, values?: any) => string